import React from 'react';
import Modal from '../../../../../components/Modal';
import InfoTable from '../../../../../components/table/InfoTable';
import CouponBenefit from '../../CouponBenefit';
import CouponPeriod from '../../CouponPeriod';
import { COUPON_AVAILABLE_TYPE_TEXT } from '../../../../../constants/service/app/couponConstants';
import './CouponDetailModal.scss';

const CouponDetailModal = (props) => {
  const { data, isOpen, closeModal } = props;
  const { couponDetail } = data;

  return (
    <Modal title="쿠폰 상세 정보" isOpen={isOpen} width={800} onClose={() => closeModal()}>
      <div className="coupon-detail-modal">
        <InfoTable>
          <tbody>
            <tr>
              <td className="label tc">쿠폰 ID</td>
              <td className="tc">{couponDetail.couponId}</td>
              <td className="label tc">쿠폰명</td>
              <td className="tc">{couponDetail.couponName}</td>
            </tr>
            <tr>
              <td className="label tc">쿠폰혜택</td>
              <td className="tc">
                <CouponBenefit type={couponDetail.discountType} amount={couponDetail.discountAmount} />
              </td>
              <td className="label tc">쿠폰유형</td>
              <td className="tc">{COUPON_AVAILABLE_TYPE_TEXT[couponDetail.availableType]}</td>
            </tr>
            <tr>
              <td className="label tc">쿠폰코드</td>
              <td className="tc">{couponDetail.code}</td>
              <td className="label tc">생성일자</td>
              <td className="tc">{couponDetail.createDate}</td>
            </tr>
            <tr>
              <td className="label tc">사용기간</td>
              <td className="tc" colSpan={3}>
                <CouponPeriod
                  type={couponDetail.periodType}
                  startDate={couponDetail.startDate}
                  endDate={couponDetail.endDate}
                  dayPlus={couponDetail.dayPlus}
                />
              </td>
            </tr>
            <tr>
              <td className="label tc">쿠폰설명</td>
              <td className="tc" colSpan={3}>
                {couponDetail.description}
              </td>
            </tr>
            <tr>
              <td className="label tc">메모</td>
              <td className="tc" colSpan={3}>
                {couponDetail.memo}
              </td>
            </tr>
          </tbody>
        </InfoTable>
      </div>
    </Modal>
  );
};

export default CouponDetailModal;
